import { render, staticRenderFns } from "./TheScreenProjectInvestors.vue?vue&type=template&id=2b14e97e&"
import script from "./TheScreenProjectInvestors.vue?vue&type=script&lang=js&"
export * from "./TheScreenProjectInvestors.vue?vue&type=script&lang=js&"
import style0 from "./TheScreenProjectInvestors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports